import Component from '../../lib/component'

export default class MaterialIconsComponent extends Component {
    static selector () {
        return '.material-icons'
    }

    constructor (opts) {
        super(opts)

        this.render()
    }

    render () {
        this.el.setAttribute('aria-hidden', true)

        if (this.el.innerText !== 'east'
                || this.el.classList.contains('material-icons-east'))
            return

        this.el.classList
            .add('material-icons-east')
    }
}
